import { auth, db } from "firebaseApp";
import { collection, query, where } from "firebase/firestore";
import { useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDispatch } from "react-redux";
import { editorActions } from "store/editor";
import { COLLECTIONS } from "firebaseCollections";

export default function ToolLoader() {

  const uid = auth.currentUser?.uid;
  
  const dispatch = useDispatch();
  
  const q = uid ? query(
    collection(db, COLLECTIONS.bots),
    where("uid", "==", uid),
    where("isTool", "==", true),
  ) : null;

  const [snapshot, loading, error] = useCollection(q);

  if(error) {
    console.log(error);
  }

  useEffect(() => {
    if(snapshot) {
      const tools = snapshot.docs.map((doc) => ({...doc.data(), id: doc.id}));
      dispatch(editorActions.initializeTools(tools.sort((x, y) => x.createdAt - y.createdAt)));
    }
  }, [snapshot]);

  return null;

}
